import React from 'react';
import styled from 'styled-components';
import { Link, useNavigate } from 'react-router-dom';

import SparkleButton from '../buttons/SparkleButton';
import calendar from '../icons/blank_calendar.png';

const CreateEventPromo = () => {
  const navigate = useNavigate();

  const onCreateClick = () => {
    navigate('/event/create');
  };

  return <>
    <ContentContainer>
      <Name>
        Enlighten your events with AI
      </Name>

      <MessageContainer>
        <Message>
          You have no upcoming events.
        </Message>
        <AccentedMessage to="/event/create">{' Host one!'}</AccentedMessage>
      </MessageContainer>

      <CalendarIcon src={calendar}></CalendarIcon>

      <ButtonWrapper>
        <SparkleButton buttonText="Create your invite" disabled={false} onClick={onCreateClick}/>
      </ButtonWrapper>
    </ContentContainer>
  </>;
};


export default CreateEventPromo;


const Name = styled.div`
  height: 28px;
  margin: 5px 0 5px;
  font-size: 24px;
  font-weight: 600;
  color: var(--shine-text-color);
`;

const Message = styled.span`
  color: #FFF;
  font-size: 16px;
`;

const ButtonWrapper = styled.div`
  width: 260px;
`;

const CalendarIcon = styled.img`

`;

const AccentedMessage = styled(Link)`
  color: #49FCF2;
  font-size: 16px;
  font-weight: 700;
  text-decoration: none;
`;

const MessageContainer = styled.div`
  font-size: 12px;
  padding: 10px 0;
  text-align: center;
`;

const ContentContainer = styled.div`
  justify-content: center;
  text-align: center;
  align-items: center;
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  min-height: 505px;
`;

